module.exports = __webpack_public_path__ + "static/media/Calendar.1abbf28d.svg";